(()=>{
 const root=document.querySelector('.ks-grip-refinement');if(!root)return;
 const yin=root.classList.contains('ks-grip-refinement--yin');
 if(yin){
  root.querySelectorAll('.ks-pdp-option small').forEach(caption=>{
   const parts=caption.textContent.split(' · ');if(parts.length!==2)return;
   const lines=parts.map(text=>{const span=document.createElement('span');span.className='yr-option-line';span.textContent=text;return span;});
   const separator=document.createElement('span');separator.className='yr-option-separator';separator.textContent=' · ';
   caption.replaceChildren(lines[0],separator,lines[1]);
  });
  const addon=root.querySelector('.ks-pdp-addon');
  const price=root.querySelector('.ks-pdp-price-row');
  if(addon&&price&&addon.closest('form')===price.closest('form'))price.before(addon);
 }
 const svg=(paths,cls,view='0 0 24 24')=>{
  const holder=document.createElement('template');
  holder.innerHTML='<svg class="'+cls+'" viewBox="'+view+'" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+paths+'</svg>';
  return holder.content.firstElementChild;
 };
 const icons=yin?[
  '<path d="M5 15V7m14 8V7M3 7h4m10 0h4M6 17h12M9 14l-3 3 3 3m6-6 3 3-3 3"/>',
  '<path d="M5 15h14M7 15v5m10-5v5M3 20h6m6 0h6M8 11l4-7 4 7"/>',
  '<path d="M5 5v8a7 7 0 0 0 14 0V5h-4v8a3 3 0 0 1-6 0V5ZM5 9h4m6 0h4"/>'
 ]:[
  '<path d="M3 5h18M10 5v10a3 3 0 0 0 6 0V9a2 2 0 0 0-4 0v12"/>',
  '<circle cx="12" cy="12" r="7"/><path d="M4 3h16M4 1v4m16-4v4M7 12h10m-2-2 2 2-2 2m-6-4-2 2 2 2"/>',
  '<path d="M7 3 3 7m12-4L3 15m20-8L7 23m16-8-8 8M3 3l18 18M11 3l10 10"/>'
 ];
 root.querySelectorAll('.ks-pdp-benefits li').forEach((li,i)=>{const old=li.querySelector('svg');if(old&&icons[i])old.replaceWith(svg(icons[i],'yr-benefit-icon'));});
 root.querySelectorAll('a.ks-assurance-item').forEach(a=>{const div=document.createElement('div');div.className=a.className;while(a.firstChild)div.append(a.firstChild);a.replaceWith(div);});
 root.querySelectorAll('.bcr-table').forEach(table=>{
  const wrapper=document.createElement('div');wrapper.className='yr-table-scroll';wrapper.tabIndex=0;wrapper.setAttribute('role','region');
  const label=table.querySelector('caption')?.textContent||table.closest('section')?.querySelector('h2')?.textContent;
  if(label)wrapper.setAttribute('aria-label',label.trim());table.before(wrapper);wrapper.append(table);
  const headers=Array.from(table.querySelectorAll('thead th')).slice(1);
  if(yin){
   const filenames=['yinyang-bar-pro.jpg','yinyang-pbar-max.jpg','yy-pro-xl.jpg','yinyang-max-xl_975f1135-ba6b-4f3a-8626-67bdd3c7c0a3.jpg'];
   headers.forEach((th,i)=>{
    const source=Array.from(root.querySelectorAll('.ks-pdp-slide img')).find(img=>(img.getAttribute('src')||'').includes(filenames[i]));
    if(!source)return;const img=document.createElement('img');img.src=source.getAttribute('src').replace(/width=\d+/,'width=360');img.alt='';img.width=180;img.height=125;img.loading='lazy';img.className='yr-model-photo';th.prepend(img);
   });
  }else{
   headers.forEach((th,i)=>{
    const end=i<2?60:89;const width=i%2?10:6;
    th.prepend(svg('<path d="M40 '+end+'V25c0-20-24-20-24 0 0 12 24 12 24 0" stroke-width="'+width+'"/><path d="M36 '+(end-5)+'h8m-8 4h8" stroke="#305c70" stroke-width="2"/>','yr-rope-diagram','0 0 64 100'));
   });
  }
 });
 const detailIcons=yin?[
  '<path d="M5 5v8a7 7 0 0 0 14 0V5h-4v8a3 3 0 0 1-6 0V5ZM5 9h4m6 0h4"/>',
  '<path d="M3 7c5-5 13 5 18 0M3 12c5-5 13 5 18 0M3 17c5-5 13 5 18 0"/><rect x="2" y="2" width="20" height="20" rx="3"/>',
  '<ellipse cx="12" cy="12" rx="7" ry="10"/><ellipse cx="12" cy="12" rx="3" ry="6"/>'
 ]:[
  '<path d="m4 3 16 18M9 3l11 12M4 9l11 12M20 3 4 21M15 3 4 15m16-6L9 21"/>',
  '<path d="M4 4h16M4 8h16M4 12h16M4 16h16M4 20h16M8 2v20m8-20v20"/>'
 ];
 root.querySelectorAll('.bcr-details article').forEach((article,i)=>{if(detailIcons[i])article.prepend(svg(detailIcons[i],'yr-detail-icon'));});
})();
